import { colors } from "theme/palette";

import Button from "components/Button";
import Tooltip from "components/Tooltip";

export interface IDownloadButton {
  children: React.ReactNode;
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
  cursorNotAllowed: boolean;
  tooltipTitle?: string;
}
const DownloadButton = ({
  tooltipTitle,
  children,
  onClick,
  loading,
  disabled,
  cursorNotAllowed,
}: IDownloadButton) => {
  return (
    <Tooltip title={tooltipTitle}>
      <span
        style={{
          cursor: cursorNotAllowed ? "not-allowed" : "inherit",
          width: "fit-content",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            display: "flex",
            color: colors.gray100,
            width: "fit-content",
            gap: 1,
            padding: 1,
          }}
          loading={loading}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </Button>
      </span>
    </Tooltip>
  );
};

export default DownloadButton;
